import { render, staticRenderFns } from "./AttachReceipt.vue?vue&type=template&id=7da8f2c9&lang=pug"
import script from "./AttachReceipt.vue?vue&type=script&lang=js"
export * from "./AttachReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports